import React from 'react';
import * as fileCrud from '../../../../crud/file.crud';
import BiDynamicForm from '../../../../partials/layout/BiDynamicForm';
import Document from '../../_CustomComponents/DocumentV2';
import BaseDocument from '../../_CustomComponents/BaseDocument';
import { withSnackbar } from 'notistack';
import DocumentDraftInfo from '../../_CustomComponents/DocumentDraftInfo';

class ProgrammeDocument extends BaseDocument {
    constructor(props) {
        super(props);
        const { fields } = this.props.workflowItem;
        this.editorFormConfig = {
            fields: [
                { label: fields.Reference.label, dataField: 'reference' },
            ]
        };
        if (fields.Type.visible) {
            this.editorFormConfig.fields.push({ label: fields.Type.label, dataField: 'type', editorType: 'dxSelectBox', editorOptions: { dataSource: fields.Type.clauses, valueExpr: 'display', displayExpr: 'display' } })
        }
        if (fields.PreviousPlanned.visible && props.contract.expectedcompletiondate) {
            this.editorFormConfig.fields.push({ label: fields.PreviousPlanned.label, dataField: 'previousplanneddate', editorType: 'dxDateBox', editorOptions: { readOnly: true, value: new Date(props.contract.expectedcompletiondate) } })
        }
        if (fields.PlannedCompletion.visible) {
            this.editorFormConfig.fields.push({ label: fields.PlannedCompletion.label, dataField: 'plannedcompletiondate', editorType: 'dxDateBox', validation: { type: 'range', min: new Date(1900, 0, 1), max: new Date(2079, 5, 6), warning: this.props.intl.formatMessage({ id: "GENERAL.FORMS.INVALID_DATE" }) } })
        }
        if (fields.Reason.visible) {
            this.editorFormConfig.fields.push({ label: fields.Reason.label, dataField: 'reasonchanged', editorType: 'dxHtmlEditor' })
        }
        if (fields.Change.visible) {
            this.editorFormConfig.fields.push({ label: fields.Change.label, dataField: 'details', editorType: 'dxHtmlEditor' })
        }
        if (fields.MainProgress.visible) {
            this.editorFormConfig.fields.push({ label: fields.MainProgress.label, dataField: 'mainprogress', editorType: 'dxHtmlEditor' })
        }
        if (fields.KeyActivities.visible) {
            this.editorFormConfig.fields.push({ label: fields.KeyActivities.label, dataField: 'keyactivities', editorType: 'dxHtmlEditor' })
        }
        if (fields.Summary.visible) {
            this.editorFormConfig.fields.push({ label: fields.Summary.label, dataField: 'summarycritical', editorType: 'dxHtmlEditor' })
        }
        if (fields.Changes.visible) {
            this.editorFormConfig.fields.push({ label: fields.Changes.label, dataField: 'mainchanges', editorType: 'dxHtmlEditor' })
        }
        if (fields.Compensation.visible) {
            this.editorFormConfig.fields.push({ label: fields.Compensation.label, dataField: 'compensationevents', editorType: 'dxHtmlEditor' })
        }

    }


    renderForm = () => {
        return (
            <BiDynamicForm
                labelLocation="top"
                item={this.props.notification}
                config={this.editorFormConfig}
                valueChangeHandler={this.props.fieldChanged}
                customFields={(this.props.customFields || {}).COMMUNICATION}
                assetFieldsEnabled={this.props.workflowItem.assetFieldsEnabled}
            />
        );
    }


    uploadFile = (data, config) => {
        const { companyid, projectid, contractid } = this.props.contract;
        return fileCrud.uploadContractNotificationFiles(companyid, projectid, contractid, this.props.documentType, this.props.notification.programid, this.props.workflowItem.id, this.props.workflowItem.config.quotationWorkflowID, data, config)
    }


    render() {
        const documentIsFinal = this.props.notification.showtasknotification === 1;
        const { createby, createdate, lastdraftedbyname, lastdrafteddate, lastdraftednotifiedtoname } = this.props.notification;

        return (
            <>
                <DocumentDraftInfo
                    documentIsFinal={documentIsFinal}
                    createbyname={createby}
                    createdate={createdate}
                    lastdraftedbyname={lastdraftedbyname}
                    lastdrafteddate={lastdrafteddate}
                    lastdraftednotifiedtoname={lastdraftednotifiedtoname}
                />
                <Document
                    key={documentIsFinal}
                    docConfig={this.props.notification.pdfjsoncontent}
                    isFinal={documentIsFinal}
                    printDivRef={this.props.printDivRef}
                    workflowItem={this.props.workflowItem}
                    contract={this.props.contract}
                    reference={this.props.notification.referenceid}
                    form={documentIsFinal ? null : this.renderForm()}
                    uploadMethod={documentIsFinal ? null : this.uploadFile}
                    onFilesCountChanged={this.props.onFilesCountChanged}
                    files={this.props.files}
                    notificationid={this.props.notificationid}
                    documentType={this.props.documentType}
                    customFields={(this.props.customFields || {}).COMMUNICATION}
                    customFieldValues={this.props.notification.customfieldvalues}
                    assetid={this.props.notification.assetid}
                    saving={this.props.saving}
                    onFileUploadFinish={this.props.onFileUploadFinish}
                    onFileUploadStart={this.props.onFileUploadStart}
                />
            </>

        );
    }
}

export default withSnackbar(ProgrammeDocument);
